import type { ComputedRef, Ref } from 'vue';
import type { ZodSchema } from 'zod';

export const useZodForm = <T>(
  schema: ZodSchema<T>,
  getData: () => unknown,
  submitted: Ref<boolean> | ComputedRef<boolean>,
) => {
  const errors = computed<Record<string, string>>(() => {
    if (!submitted.value) {
      return {};
    }
    const result = schema.safeParse(getData());
    return result.success ? {} : flattenZodIssues(result.error);
  });

  const isValid = computed(() => Object.keys(errors.value).length === 0);

  return { errors, isValid };
};
